import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Lock } from '@tink/core/src/components/atoms/Icons/Lock';
import { Profile } from '@tink/core/src/components/atoms/Icons/Profile';
import { Caption } from '../../../../../../../../../components/atoms/Text/Text';

import { messages as accountSelectionMessages } from '../AccountSelectionDisclaimer/messages';
import { messages as sourceAccountSelectionMessages } from '../SourceAccountSelectionDisclaimer/messages';
import { messages } from '../../../../../../molecules/ConsentDisclaimer/messages';
import { TemplateNoticeContainer, TemplateNoticeText } from './TemplateNotice.styles';

export const TemplateNotice = () => (
  <TemplateNoticeContainer>
    <Profile color="greyBlack" />

    <TemplateNoticeText ml="xsmall" pl="xsmall">
      <Caption color="secondary">
        <FormattedMessage {...messages.header} />
      </Caption>
    </TemplateNoticeText>
  </TemplateNoticeContainer>
);

export const AccountSelectionTemplateNotice = () => (
  <TemplateNoticeContainer>
    <Lock color="greyBlack" />

    <TemplateNoticeText ml="xsmall" pl="xsmall">
      <Caption color="secondary">
        <FormattedMessage {...accountSelectionMessages.accountData} />
      </Caption>
    </TemplateNoticeText>
  </TemplateNoticeContainer>
);

export const SourceAccountSelectionTemplateNotice = () => (
  <TemplateNoticeContainer>
    <Lock color="greyBlack" />

    <TemplateNoticeText ml="xsmall" pl="xsmall">
      <Caption color="secondary">
        <FormattedMessage {...sourceAccountSelectionMessages.consentHeader} />
      </Caption>
    </TemplateNoticeText>
  </TemplateNoticeContainer>
);
